export default {
  SELECT_LIST_FILL_POPOVER: 'select-list--fill-popover',
  SELECT_LIST_FILL_BUTTON: 'select-list--fill-button',
  SELECT_LIST_TOOLTIP_ITEMS: 'select-list--tooltip-items',

  FINANCIAL_SHEET_MINIMAL: 'financial-sheet--minimal'
}